module.exports = __webpack_public_path__ + "static/brain-38ccdc733e05435543126f8a3d1e38b4.png";